import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-iframe-modal',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule],
    template: `
        <div class="iframe-modal">
            <button mat-icon-button class="close-button" (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
            <iframe
                [src]="safeUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none;">
            </iframe>
        </div>
    `,
    styles: [`
        .iframe-modal {
            position: relative;
            width: 100%;
            height: 100%;
        }
        .close-button {
            position: absolute;
            top: -5px;
            right: -5px;
            z-index: 1000;
        }
    `]
})
export class IframeModalComponent {
    safeUrl: SafeResourceUrl;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { iframeUrl: string },
        private dialogRef: MatDialogRef<IframeModalComponent>,
        private sanitizer: DomSanitizer,
    ) {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.iframeUrl);
    }

    closeModal(): void {
        this.dialogRef.close();
    }
}
